import React from 'react';
import TitleSectionMaster from '../atoms/TitleSectionMaster';
import SectionExperienceInTheThecnology from '../organisms/SectionExperienceInTheThecnology';

const PresentationExperencieAndLenguages = () => (
    <>
        <section className="presentation-i-am">
            < TitleSectionMaster title="Tecnologias que manejo y aprendo" />
        
            <section className="grid-experencie-lenguages">
                < SectionExperienceInTheThecnology />
            </section>
        </section>
    </>
)


export default PresentationExperencieAndLenguages;
